module.exports = __webpack_public_path__ + "3f16e137/img/file-icon.c085e21e.svg";